export default __webpack_public_path__ + "static/media/SurfaceBook.aa31f714.svg";